import React, { createContext, useContext, useEffect, useState } from "react";

const OffersContext = createContext();
export function useOffers() {
  const ctx = useContext(OffersContext);
  if (!ctx) {
    throw new Error("useOffers must be used within an OffersProvider");
  }
  return ctx;
}

/**
 * This function creates a provider to retrieve offers data from the backend. 
 * Components can access this providers data through the exposed useOffers context.
 * @callback SetDisclosuresCallBack
 * @param {SetDisclosuresCallBack} setDisclosures Callback to set the disclosures in the PropView
 * @param {function(boolean)} onLoadingChange Optional callback when loading state changes (e.g. for getQuoteV2)
 * @param {*} children Children of Provider  
 * @returns {OffersContext.Provider}
 */
export default function OffersProvider({ setDisclosures, onLoadingChange, children }) {
  const [offers, setOffers] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState();
  const [offer, setOffer] = useState();
  const [lrAcctId, setLrAcctId] = useState();

  useEffect(() => {
    if (onLoadingChange) {
      onLoadingChange(isLoading);
    }
  }, [isLoading, onLoadingChange]);

  const getOffers = async (payload, getOffersDTO, setLightReachAcctId = f => f, checkLightReach = false, onSuccess = f => f) => {
    const ac = new AbortController();
    setLoading(true);

    try {
      const offersResp = await getOffersDTO(payload);
      if (offersResp?.offers) {
        const sortedOffers = offersResp.offers.sort((a, b) => b.escalatorRate - a.escalatorRate);
        setOffers(sortedOffers);
        if (!offer) {
          setOffer(sortedOffers[0]);
        }
      }
      if (offersResp?.disclosures) {
        setDisclosures(offersResp.disclosures[0].sections);
      }
      if (offersResp?.lrId) {
        setLrAcctId(offersResp.lrId);
      }
      setErrorMessage(null);
      setLoading(false);
      onSuccess(offersResp);
    } catch (error) {
      setErrorMessage(error.message);
      setLoading(false);
      return () => ac.abort();
    }
  };

  return (
    <OffersContext.Provider value={{ offers, offer, setOffer, isLoading, errorMessage, getOffers, lrAcctId, }}>
      {children}
    </OffersContext.Provider>
  );
};